import React from 'react';
import { ShieldCheck, Leaf, Handshake } from 'lucide-react';
import { useT } from '../i18n/LanguageContext';

const icons = [ShieldCheck, Leaf, Handshake];

const Story = () => {
  const { t } = useT();

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        <div className="grid lg:grid-cols-2 gap-16 items-start">

          {/* LEFT CONTENT */}
          <div>

            {/* Badge */}
            <span className="inline-block px-3 py-1 rounded-full border border-slate-200 bg-slate-50 text-slate-600 text-[11px] tracking-[0.25em] font-semibold">
              {t.story.badge}
            </span>

            {/* Title */}
            <h2 className="mt-6 text-4xl md:text-5xl font-black text-[#0b1c3a] leading-[1.05] tracking-tight">
              {t.story.titleA}{' '}
              <span className="text-[#0b3b8c] italic font-serif">
                {t.story.titleAccent}
              </span>
            </h2>

            {/* Paragraph 1 */}
            <p className="mt-6 text-slate-600 leading-relaxed">
              {t.story.p1}
            </p>

            {/* Paragraph 2 */}
            <p className="mt-4 text-slate-600 leading-relaxed">
              {t.story.p2}
            </p>

            {/* About button */}
            <a
              href="/about"
              className="inline-flex mt-8 px-6 py-3 rounded-full bg-[#0b3b8c] text-white font-semibold text-sm hover:bg-[#082e6f] transition-colors"
            >
              {t.common.learnMore}
            </a>

          </div>

          {/* RIGHT FEATURES */}
          <div className="space-y-4">

            {t.story.features.map((feature, index) => {
              const Icon = icons[index];

              return (
                <div
                  key={feature.title}
                  className="group flex gap-5 p-6 rounded-2xl border border-slate-200 bg-white hover:shadow-xl hover:border-[#0b3b8c]/30 transition-all"
                >

                  {/* Icon */}
                  <div className="shrink-0 w-11 h-11 rounded-xl bg-[#f5c518]/15 text-[#c19a00] flex items-center justify-center">
                    <Icon
                      className="w-5 h-5"
                      strokeWidth={2.2}
                    />
                  </div>

                  {/* Feature text */}
                  <div>
                    <h3 className="text-[#0b1c3a] font-bold text-lg">
                      {feature.title}
                    </h3>

                    <p className="text-slate-600 text-sm mt-1 leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>

                </div>
              );
            })}

            {/* Bottom Stats */}
            <div className="grid grid-cols-3 gap-4 pt-8 mt-4 border-t border-slate-200">

              {t.story.bottomStats.map((stat) => (
                <div key={stat.label}>

                  <div className="text-[#0b1c3a] text-2xl md:text-3xl font-black">
                    {stat.value}
                  </div>

                  <div className="text-slate-500 text-[10px] tracking-[0.2em] font-semibold mt-1">
                    {stat.label}
                  </div>

                </div>
              ))}

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default Story;